import type { IconNode } from '../types';

/**
 * @name pen-tool
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTggMTMtLjY1NC00LjczNmE0IDQgMCAwMC0yLjc1Ni0zLjI2NmwtOS4xNjMtMi45YTIgMiAwIDAwLTIuMDE3LjQ5M2wtLjgyLjgxOWEyIDIgMCAwMC0uNDkyIDIuMDE3bDIuOSA5LjE2M2E0IDQgMCAwMDMuMjY2IDIuNzU2TDEzIDE4IiAvPgogIDxwYXRoIGQ9Ik0xOC42NDggMTIuMzUyYTEuMjA1IDEuMjA1IDAgMDExLjcwNCAwbDEuMjk2IDEuMjk2YTEuMjA1IDEuMjA1IDAgMDEwIDEuNzA0bC02LjI5NiA2LjI5NmExLjIwNSAxLjIwNSAwIDAxLTEuNzA0IDBsLTEuMjk2LTEuMjk2YTEuMjA1IDEuMjA1IDAgMDEwLTEuNzA0eiIgLz4KICA8cGF0aCBkPSJtMyAzIDYuNTg2IDYuNTg2IiAvPgogIDxjaXJjbGUgY3g9IjExIiBjeT0iMTEiIHI9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/pen-tool
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const PenTool: IconNode = [
  [
    'path',
    {
      d: 'm18 13-.654-4.736a4 4 0 00-2.756-3.266l-9.163-2.9a2 2 0 00-2.017.493l-.82.819a2 2 0 00-.492 2.017l2.9 9.163a4 4 0 003.266 2.756L13 18',
    },
  ],
  [
    'path',
    {
      d: 'M18.648 12.352a1.205 1.205 0 011.704 0l1.296 1.296a1.205 1.205 0 010 1.704l-6.296 6.296a1.205 1.205 0 01-1.704 0l-1.296-1.296a1.205 1.205 0 010-1.704z',
    },
  ],
  ['path', { d: 'm3 3 6.586 6.586' }],
  ['circle', { cx: '11', cy: '11', r: '2' }],
];

export default PenTool;
